import { BlankState } from '@domain-group/suit-theme'

import BlankStateImage from './assets/no-auctions.svg'

const AuctionsBlankState = () => (
  <BlankState boxProps={{ marginBottom: 'large' }} imageUrl={BlankStateImage}>
    <BlankState.Title>No Auctions Available</BlankState.Title>

    <BlankState.Paragraph>
      No campaign auctions to display. Auctions will automatically feed from your CRM if set,
      otherwise you can add an auction date and time in the campaigns property details page.
    </BlankState.Paragraph>
  </BlankState>
)

AuctionsBlankState.propTypes = {}

export default AuctionsBlankState
